__turbopack_context__.v({
  "className": "gamja_flower_f48efbcc-module__ajUbjW__className",
});
